/* @flow */
import produce from 'immer'

export default function reducer(
  state,
  action: any
) {
  return produce(state, draft => {
    switch (action.type) {
      case 'CHANGE_PARAGRAPH':
        draft.paragraph = action.value
        return
      case 'CHANGE_COPYRIGHT':
        draft.copyrightText = action.value
        return
      case 'CHANGE_NAVBAR_LOGO':
        const { url, dimensions } = action.value
        draft.logoSrc = url
        draft.logoDimensions = dimensions || {}
        draft.logoWidth = null
        return
      case 'REMOVE_NAVBAR_LOGO':
        draft.logoSrc = ''
        draft.logoDimensions = {}
        draft.logoWidth = null
        return
      case 'RESIZE_LOGO':
        draft.logoWidth = action.value
        return
      case 'CHANGE_LOGO_COLOR':
        draft.logoColor = action.value
        return
    }
  })
}
